import { isMobile } from './src-utils-mobile-utils.js';

const logCodeMapping = {
  CA_ERROR: "CA001",
  CA_CHAT_ESTABLISHED: "CA997",
  CA_CHAT_REQUEST_SUCCESS: "CA996",
  CA_HELP_BUTTON_CLICKED: "CA994",
  CA_CHAT_ENDED_BY_USER: "CA993",
  CA_CHAT_ENDED_BY_AGENT: "CA992",
  CA_DISABLED_CLICK: "CA986",
  CA_OUTSIDE_BUSINESS_HR: "CA983"
  // This is used for Business Hr Check
};
const logMapping = (logName, locale) => {
  const commonAttributes = {
    deploymentName: `chat-anywhere-custom-miaw-${locale}-chat`,
    locale,
    deviceType: isMobile() ? "mobile" : "desktop",
    env: window.location.href.includes("staging") || window.location.href.includes("localhost") ? "dev" : "production",
    logCode: logCodeMapping[logName],
    logName,
    miaw: true,
    customMiaw: true
  };
  switch (logName) {
    case "CA_OUTSIDE_BUSINESS_HR":
      return { ...commonAttributes, logLevel: "info", message: "CA: Outside Business Hour" };
    case "CA_CHAT_ESTABLISHED":
      return { ...commonAttributes, logLevel: "info", message: "CA: Chat Established" };
    case "CA_CHAT_REQUEST_SUCCESS":
      return { ...commonAttributes, logLevel: "info", message: "CA: Chat Request Success" };
    case "CA_HELP_BUTTON_CLICKED":
      return { ...commonAttributes, logLevel: "info", message: "CA: Help Button Clicked" };
    case "CA_CHAT_ENDED_BY_USER":
      return { ...commonAttributes, logLevel: "info", message: "CA: Chat ended by user" };
    case "CA_CHAT_ENDED_BY_AGENT":
      return { ...commonAttributes, logLevel: "info", message: "CA: Chat ended by agent" };
    case "CA_DISABLED_CLICK":
      return { ...commonAttributes, logLevel: "info", message: "CA: Disabled CTA clicked" };
    case "CA_ERROR":
    default:
      return { ...commonAttributes, logLevel: "error", message: "CA: Error occured " };
  }
};

export { logCodeMapping, logMapping };
//# sourceMappingURL=src-utils-chat-chat-nr-logging.js.map
